var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEitaa = function SvgEitaa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474239",
    fillRule: "evenodd",
    d: "M5.714 0h8.572C17.429 0 20 2.505 20 5.572v2.689c-2.818 1.236-5.66 7.34-9.803 6.013-.341.237-1.127 1.212-1.183 1.952-1.434-.187-3.088-1.79-2.89-3.52-2.387-1.686-.415-4.797 1.478-6.049 4.058-2.684 9.692-.376 6.558 1.543-1.905 1.167-5.98 1.938-5.557-.927-1.117.315-1.833 2.349-.487 3.409-1.247 1.195-1.007 3.392.325 4.113 1.348-3.407 6.04-2.962 7.934-7.03 1.427-3.06-.688-6.546-4.914-6.01-3.19.404-6.18 3.03-7.676 6.144-1.517 3.16-1.292 7.39 1.824 9.523 3.667 2.51 7.57.186 9.934-2.851 1.394-1.79 2.612-3.773 4.457-4.918v4.767c0 3.067-2.572 5.58-5.714 5.58H5.714C2.571 20 0 17.49 0 14.424V5.576C0 2.509 2.571 0 5.714 0",
    clipRule: "evenodd"
  })));
};
export default SvgEitaa;